import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Jsa } from './jsa.interface';
import { environment } from '../../../environments/environment';
import { buildAnalyticsParams } from '../analytics-params';


@Injectable({
  providedIn: 'root',
})
export class JsaService {
    private apiUrl = `${environment.apiConfig.uri}/jsa`;
    private apiUrlSearch = `${environment.apiConfig.uri}/jsa/search`;
    private apiUrlPdf = `${environment.apiConfig.uri}/jsa/export-pdf`;
    private apiUrlExport = `${environment.apiConfig.uri}/jsa/export`;
    private apiUrlAnalytics = `${environment.apiConfig.uri}/jsa/analytics`;
    private apiUrlMonthly = `${environment.apiConfig.uri}/jsa/jsaTotals`;
    private apiUrlAnalyticsAll = `${environment.apiConfig.uri}/jsa/analyticsAll`;

    constructor(private http: HttpClient) {
    }

    createJsa(newJsa: Jsa): Observable<any> {
        return this.http.post(this.apiUrl, {
            email: newJsa.email,
            office: newJsa.office,
            clientName: newJsa.clientName,
            projectNumber: newJsa.projectNumber,
            projectName: newJsa.projectName,
            userDateTime: newJsa.userDateTime,
            // date: newJsa.date,
            // time: newJsa.time,
            desc: newJsa.desc,
            equipmentUsed: newJsa.equipmentUsed,
            hazards: newJsa.hazards,
            hospitalName: newJsa.hospitalName,
            hospitalAddress: newJsa.hospitalAddress,
            hospitalTele: newJsa.hospitalTele,
            ucName: newJsa.ucName,
            ucAddress: newJsa.ucAddress,
            ucTele: newJsa.ucTele,
            safeWork: newJsa.safeWork,
            personalEquip: newJsa.personalEquip,
            enviroImpact: newJsa.enviroImpact,
            stepOne: newJsa.stepOne,
            hazardOne: newJsa.hazardOne,
            actionOne: newJsa.actionOne,
            stepTwo: newJsa.stepTwo,
            hazardTwo: newJsa.hazardTwo,
            actionTwo: newJsa.actionTwo,
            stepThree: newJsa.stepThree,
            hazardThree: newJsa.hazardThree,
            actionThree: newJsa.actionThree,
            stepFour: newJsa.stepFour,
            hazardFour: newJsa.hazardFour,
            actionFour: newJsa.actionFour,
            stepFive: newJsa.stepFive,
            hazardFive: newJsa.hazardFive,
            actionFive: newJsa.actionFive,
            ynOne: newJsa.ynOne,
            ynTwo: newJsa.ynTwo,
            ynThree: newJsa.ynThree,
            ynFour: newJsa.ynFour,
            ynFive: newJsa.ynFive,
            signature1: newJsa.signature1,
            signature2: newJsa.signature2,
            signature3: newJsa.signature3,
            signature4: newJsa.signature4,
            signature5: newJsa.signature5,
        });
    }

    exportJsaExcel(startDate?: Date, endDate?: Date): Observable<Blob> {
        let params = new HttpParams();
        if (startDate) params = params.set('startDate', startDate.toISOString());
        if (endDate) params = params.set('endDate', endDate.toISOString());
        return this.http.get(this.apiUrlExport, {
            params,
            responseType: 'blob'
        })
    }

    findJsaById(jsaId: string): Observable<any> {
        return this.http.get(this.apiUrl + jsaId);
    }

    getJsaAnalytics(offices?: string[], startDate?: Date, endDate?: Date): Observable<any> {
        return this.http.get(this.apiUrlAnalytics, { params: buildAnalyticsParams(offices, startDate, endDate) });
    }
    
    getPdfs(office: string, startDate: Date, endDate: Date): Observable<any> {
        const params = new HttpParams()
            .set('office', office)
            .set('startDate', startDate.toISOString())
            .set('endDate', endDate.toISOString());
        return this.http.get(this.apiUrlPdf, { params })
            
    }

    getJsaTotalAnalytics(): Observable<any> {
        return this.http.get<any>(this.apiUrlAnalyticsAll);
    }

    getJsaTotalsByMonth(offices?: string[], startDate?: Date, endDate?: Date): Observable<any> {
        return this.http.get<any>(this.apiUrlMonthly, { params: buildAnalyticsParams(offices, startDate, endDate) });
    }

    searchJsaReport(office: string, startDate: Date, endDate: Date): Observable<any> {
        const params = new HttpParams()
            .set('office', office)
            .set('startDate', startDate.toISOString().split('T')[0] + 'T00:00:00.000Z')
            .set('endDate', endDate.toISOString().split('T')[0] + 'T23:59:59.999Z');
        return this.http.get(this.apiUrlSearch, { params });
    }

    updateJsa(jsaId: string, updatedJsa: Jsa): Observable<any> {
        return this.http.put(this.apiUrl + jsaId, {
            email: updatedJsa.email,
            office: updatedJsa.office,
            clientName: updatedJsa.clientName,
            projectNumber: updatedJsa.projectNumber,
            projectName: updatedJsa.projectName,
            userDateTime: updatedJsa.userDateTime,
            // date: updatedJsa.date,
            // time: updatedJsa.time,
            desc: updatedJsa.desc,
            equipmentUsed: updatedJsa.equipmentUsed,
            hazards: updatedJsa.hazards,
            hospitalName: updatedJsa.hospitalName,
            hospitalAddress: updatedJsa.hospitalAddress,
            hospitalTele: updatedJsa.hospitalTele,
            ucName: updatedJsa.ucName,
            ucAddress: updatedJsa.ucAddress,
            ucTele: updatedJsa.ucTele,
            safeWork: updatedJsa.safeWork,
            personalEquip: updatedJsa.personalEquip,
            enviroImpact: updatedJsa.enviroImpact,
            stepOne: updatedJsa.stepOne,
            hazardOne: updatedJsa.hazardOne,
            actionOne: updatedJsa.actionOne,
            stepTwo: updatedJsa.stepTwo,
            hazardTwo: updatedJsa.hazardTwo,
            actionTwo: updatedJsa.actionTwo,
            stepThree: updatedJsa.stepThree,
            hazardThree: updatedJsa.hazardThree,
            actionThree: updatedJsa.actionThree,

            stepFour: updatedJsa.stepFour,
            hazardFour: updatedJsa.hazardFour,
            actionFour: updatedJsa.actionFour,
            stepFive: updatedJsa.stepFive,
            hazardFive: updatedJsa.hazardFive,
            actionFive: updatedJsa.actionFive,


            ynOne: updatedJsa.ynOne,
            ynTwo: updatedJsa.ynTwo,
            ynThree: updatedJsa.ynThree,
            ynFour: updatedJsa.ynFour,
            ynFive: updatedJsa.ynFive,
            signature1: updatedJsa.signature1,
            signature2: updatedJsa.signature2,
            signature3: updatedJsa.signature3,
            signature4: updatedJsa.signature4,
            signature5: updatedJsa.signature5,
        });
    }
}